import React, { useMemo, useState } from "react";
import { useClients } from "../contexts/ClientsContext";
import ClientCard from "../components/ClientCard";
import { Input } from "../components/ui/input";
import { Search } from "lucide-react";

const ClientsPage = () => {
  const { clients } = useClients();
  const industries = ["All", ...Array.from(new Set(clients.map((c) => c.industry)))];
  const [q, setQ] = useState("");
  const [industry, setIndustry] = useState("All");

  const filtered = useMemo(() => {
    return clients.filter((c) => {
      const matchesQ =
        !q ||
        c.name.toLowerCase().includes(q.toLowerCase()) ||
        c.industry.toLowerCase().includes(q.toLowerCase()) ||
        c.summary.toLowerCase().includes(q.toLowerCase());
      const matchesI = industry === "All" || c.industry === industry;
      return matchesQ && matchesI;
    });
  }, [q, industry, clients]);

  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-24">
      <header className="mb-12 md:mb-16 fade-up">
        <p className="font-mono-label text-[#F62493] mb-4">The Client Index</p>
        <h1 className="font-display text-5xl md:text-7xl leading-[1] text-stone-100 max-w-4xl">
          Every brand. Every campaign. <em className="italic text-[#F62493]">Organized by client.</em>
        </h1>
        <p className="mt-6 text-lg text-stone-200 max-w-2xl">
          Browse {clients.length} client collaborations spanning beverage, finance, tech, wellness, non-profit, and beyond.
        </p>
      </header>

      {/* Filters */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 mb-10 pb-6 border-b border-stone-800">
        <div className="relative w-full md:w-80">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-300" />
          <Input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search clients, industries, keywords..."
            className="pl-9 bg-transparent border-stone-400 focus-visible:ring-[#F62493]"
          />
        </div>
        <div className="flex flex-wrap gap-2">
          {industries.map((i) => (
            <button
              key={i}
              onClick={() => setIndustry(i)}
              className={`font-mono-label px-4 py-2 rounded-full border transition-colors ${
                industry === i
                  ? "bg-[#171717] text-[#F7F3ED] border-stone-900"
                  : "border-stone-400 text-stone-200 hover:border-stone-900"
              }`}
            >
              {i}
            </button>
          ))}
        </div>
      </div>

      {/* Grid */}
      {filtered.length > 0 ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
          {filtered.map((c, i) => (
            <ClientCard key={c.slug} client={c} index={i} />
          ))}
        </div>
      ) : (
        <div className="py-20 text-center">
          <p className="font-display text-3xl text-stone-200">No clients match those filters.</p>
          <button
            onClick={() => { setQ(""); setIndustry("All"); }}
            className="mt-4 font-mono-label text-[#F62493] link-underline"
          >
            Reset filters
          </button>
        </div>
      )}
    </div>
  );
};

export default ClientsPage;
